import { useEffect, useState } from "react";

import MainButton from "~/components/common/mainButton";
import { Loader } from "~/components/ui/loader";
import { useAuth } from "~/contexts/providers/auth";
import { useLanguage } from "~/contexts/providers/language";
import englishTranslations from "~/localization/en";
import frenchTranslations from "~/localization/fr";
import { formatSimpleDate } from "~/utils/functions/date.functions";

import styles from "./index.module.scss";

type BirthdayRange = {
  oneWeekBefore: Date;
  oneWeekAfter: Date;
};

const Birthday = () => {
  const { user } = useAuth();
  const { language } = useLanguage();

  const [birthdayRange, setBirthdayRange] = useState<BirthdayRange>();

  const book =
    language === "En"
      ? englishTranslations.accountPage.book
      : frenchTranslations.accountPage.book;
  const paragraph1 =
    language === "En"
      ? englishTranslations.accountPage.birthday.paragraph1
      : frenchTranslations.accountPage.birthday.paragraph1;
  const paragraph2 =
    language === "En"
      ? englishTranslations.accountPage.birthday.paragraph2
      : frenchTranslations.accountPage.birthday.paragraph2;
  const notifyText =
    language === "En"
      ? englishTranslations.accountPage.birthday.notifyText
      : frenchTranslations.accountPage.birthday.notifyText;
  const from =
    language === "En"
      ? englishTranslations.accountPage.from
      : frenchTranslations.accountPage.from;
  const to =
    language === "En"
      ? englishTranslations.accountPage.to
      : frenchTranslations.accountPage.to;

  useEffect(() => {
    if (user?.birthDate) {
      const birthdate = new Date(user?.birthDate);

      const oneWeekBefore = new Date();
      oneWeekBefore.setDate(birthdate.getDate() - 7);

      const oneWeekAfter = new Date();
      oneWeekAfter.setDate(birthdate.getDate() + 7);
      setBirthdayRange({ oneWeekBefore, oneWeekAfter });
    }
  }, [user?.birthDate]);

  return (
    <section className="p-1 btg">
      {birthdayRange ? (
        <>
          {/* <h5 className="small-title">Special Request</h5> */}
          <p className={styles.paragraph}>
            {paragraph1} <br />
            {paragraph2} <br />
            {notifyText}
          </p>
          <p className={styles.fromTo}>
            {from}&nbsp;&nbsp;
            <span>
              {formatSimpleDate(birthdayRange.oneWeekBefore, language)}
            </span>
            &nbsp;&nbsp;{to}&nbsp;&nbsp;
            <span>
              {formatSimpleDate(birthdayRange.oneWeekAfter, language)}
            </span>
          </p>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://bookings.zenchef.com/results?rid=352396&pid=1001"
          >
            <MainButton className={styles.button}>{book}</MainButton>
          </a>
        </>
      ) : (
        <Loader />
      )}
    </section>
  );
};

export default Birthday;
